/** Use for ranges such as "pages 10–15", "May–June", "9:00–5:00" */
export const EN_DASH = '–';
/** Use to create a break in thought (ajatusviiva) */
export const EM_DASH = '—';
